import { createContext } from 'react';

import { OfferModel } from '../../../../../offer/model/OfferModel';

interface RfqOfferCardContextValue {
    offer: OfferModel;
}

export const RfqOfferCardContext = createContext<RfqOfferCardContextValue | undefined>(undefined);
